import {useMemo} from 'react';

import {useLocalize} from '../../../../../srcCommon/internationalization/internationalizationContext';
import {useAppSelector} from '../../../../helpers/reduxHelpers';
import {AnalyticsMetricError} from '../../../../models/api/analyticsMetricsModel';
import {makeGetAnalyticsMetric} from '../../../../store/panels/analytics/report/analyticsPanelReportSelectors';
import {
  AnalyticsComputedProgressMetric,
  getComputedMetricTransformer,
} from '../../../transformers/analyticsMetricsTransformers';
import {
  AnalyticsComputedMetricTypesEnum,
  AnalyticsComputedProgressMetricsEnum,
} from '../../../transformers/analyticsMetricsTransformersTypes';
import {ProgressSerie} from '../../charts/components/progressBar/progressBarSerie';

export function useProgressMetricData(
  selectedMetric: AnalyticsComputedProgressMetricsEnum,
  loadingStatePredicate: (metricData?: AnalyticsComputedProgressMetric) => boolean,
  mockData: ReadonlyArray<ProgressSerie>,
): [AnalyticsComputedProgressMetric | undefined, AnalyticsMetricError | undefined] {
  const localize = useLocalize();
  const [storeMetricData, storeMetricError] = useAppSelector(
    makeGetAnalyticsMetric(getComputedMetricTransformer(selectedMetric).from),
  );

  const progressMetricData = useMemo(
    () => getComputedMetricTransformer(selectedMetric).transformer(storeMetricData, localize),
    [localize, selectedMetric, storeMetricData],
  );

  if (loadingStatePredicate(progressMetricData)) {
    return [
      {
        id: selectedMetric,
        isEmpty: false,
        series: mockData,
        metricType: AnalyticsComputedMetricTypesEnum.CUSTOM_PROGRESS,
      },
      undefined,
    ];
  }

  return [progressMetricData, storeMetricError];
}
